import { defineStore } from "pinia"

export const useUserStore = defineStore("user", {
  state: () => ({
    email: ""
  }),
  persist: true,
  actions: {
    setEmail(email) {
      this.email = email
    }
  }
})
